<img class="upload-image" [ngClass]="{'image-contain': imageContain}" src="{{_image.data || _image.url}}" *ngIf="_image">
<div class="upload-image-progress" *ngIf="percent!==undefined">
    <circle-progress [startFromZero]="false" [percent]="percent" [@FadeOut] *ngIf="showProgress"></circle-progress>
</div>
<div class="upload-image-close pointer" (click)="removeImage()" *ngIf="hasClose">
    <ion-icon color="black1" name="close-outline"></ion-icon>
</div>